/**
 * Cacular input should disable dependency status
 * @param status
 * @returns
 */
export const disableStatus = (status: 'active' | 'reject' | 'wait' | null) =>
  status === 'active' || status === 'wait' ? true : false;
